// extracted by mini-css-extract-plugin
export default {"h2":"SectionTitle_h2__KGqHd","h4":"SectionTitle_h4__+a+U3","infoIcon":"SectionTitle_infoIcon__nN0la","info":"SectionTitle_info__9c2x-","wrapper":"SectionTitle_wrapper__6G-2b"};